import React, { useLayoutEffect, useRef } from "react";
import Select from "react-select";

const SelectComponent = React.memo(
  ({ active, rowData, setRowData, focus, stopEditing, columnData }) => {
    const ref = useRef(null);
    const value = columnData.isMulti
      ? columnData.choices.filter(({ value }) => rowData?.includes(value)) ??
        null
      : columnData.choices.find(({ value }) => value === rowData) ?? null;
    useLayoutEffect(() => {
      if (focus) {
        ref.current?.focus();
      } else {
        ref.current?.blur();
      }
    }, [focus]);
    
    return (
      <Select
        ref={ref}
        isMulti={columnData.isMulti}
        styles={{
          container: (provided) => ({
            ...provided,
            flex: 1,
            alignSelf: "stretch",
            pointerEvents: focus ? undefined : "none",
          }),
          control: (provided) => ({
            ...provided,
            height: "100%",
            border: "none",
            boxShadow: "none",
            background: "none",
          }),
          indicatorSeparator: (provided) => ({
            ...provided,
            opacity: 0,
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            opacity: active ? 1 : 0,
          }),
          placeholder: (provided) => ({
            ...provided,
            opacity: active ? 1 : 0,
          }),
        }}
        isDisabled={columnData.disabled}
        value={value}
        menuPortalTarget={document.querySelector("#survey-portal")}
        menuIsOpen={focus}
        onChange={(choice) => {
          if (choice === null) return;

          if (columnData.isMulti) {
            setRowData(choice.map(({ value }) => value));
          } else {
            setRowData(choice.value);
          }
          setTimeout(stopEditing, 0);
        }}
        onMenuClose={() => stopEditing({ nextRow: false })}
        options={columnData.choices}
      />
    );
  }
);

export const selectColumn = (options) => ({
  component: SelectComponent,
  columnData: options,
  disableKeys: true,
  keepFocus: true,
  disabled: options.disabled,
  deleteValue: () => null,
  copyValue: ({ rowData }) =>
    options.choices.find((choice) => choice.value === rowData)?.label ?? null,
  pasteValue: ({ value }) =>
    options.choices.find((choice) => choice.label === value)?.value ?? null,
});
